const utils = require('frontend-controller/lib/utils')

module.exports = {
    config: {
        isCacheable: false,
    },

    model: {
        activationData: {},
    },

    methods: {
        prepare(storage){
            if(storage.isServer){
                if((storage.session || {}).activationData && !storage.session.activationData.shown){
                    this.model.activationData = {
                        userAttributes: utils.simpleCopy(storage.session.activationData.userAttributes),
                        operations:     utils.simpleCopy(storage.session.activationData.operations),
                    }
                    storage.session.activationData.shown = true
                }
            }
        },
    },
}